import type { OnDestroy, OnInit } from '@angular/core';
import {
  Directive,
  ElementRef,
  EventEmitter,
  inject,
  Output,
} from '@angular/core';
import { GlobalClickService } from '@freelancer/global-click';
import { Subscription } from 'rxjs';

/**
 * Emits if the user clicks outside the host element.
 */
@Directive({
  selector: `
   [flOutsideClick],
  `,
  standalone: true,
})
export class OutsideClickDirective implements OnInit, OnDestroy {
  private elementRef = inject(ElementRef);
  private globalClick = inject(GlobalClickService);

  @Output()
  outsideClick: EventEmitter<MouseEvent> = new EventEmitter();

  private subscription = new Subscription();

  ngOnInit(): void {
    this.subscription.add(
      this.globalClick.clicked$.subscribe(event => {
        if (!this.elementRef.nativeElement.contains(event.target)) {
          this.outsideClick.emit(event);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
